import { forwardRef } from 'react';
import type { ForwardedRef } from 'react';
import { useAppConfig } from '@tmsw/powerups.config.app.provider';
import type { ButtonProps } from '@tmsw/powerups.ui.buttons.button';
import { Button } from '@tmsw/powerups.ui.buttons.button';

export interface CircleButtonProps extends ButtonProps { };

export const CircleButton = forwardRef((props: CircleButtonProps, ref: ForwardedRef<HTMLButtonElement>) => {

  const appConfig = useAppConfig();

  props = {
    variant: appConfig?.components?.CircleButton?.defaultVariant,
    color: appConfig?.components?.CircleButton?.defaultColor,
    size: appConfig?.components?.CircleButton?.defaultSize,
    ...props
  };

  const { css } = props;

  return (
    <Button
      ref={ref}
      shape="circle"
      css={{
        zIndex: 101,
        display: 'block',
        ...css
      }}
      size="md"
      {...props}
    />
  );
});
